import { FC } from 'react';
import { NudosGenericModal, NudosModalContent } from '../../../../../components/NudosComponents';
import ConfirmedToActiveModalLsContent from './ConfirmedToActiveModalLsContent';
import { TchangeLogisticServiceStatusCallback } from '../LogisticsServicesTrelloModals';
import { IlogisticServiceDetails, IlogisticServiceTrelloCardData } from '../../../../../types/services';

export interface IConfirmedToActiveModalLS {
  updateDataCallback: TchangeLogisticServiceStatusCallback;
  closeAndRestoreList: () => void;
  modalButtonIsLoading?: boolean;
  logisticServiceDetails?: IlogisticServiceDetails;
  closeModalAfterSubmitCallback: () => void;
  selectedLogisticServiceDataForModal: IlogisticServiceTrelloCardData;
}

/**
 * Modal para confirmar el paso de En proceso a Activo en un servicio logístico.
 */
const ConfirmedToActiveModalLS: FC<IConfirmedToActiveModalLS> = ({
  updateDataCallback,
  closeAndRestoreList,
  modalButtonIsLoading,
  logisticServiceDetails,
  closeModalAfterSubmitCallback,
  selectedLogisticServiceDataForModal
}: IConfirmedToActiveModalLS) => {
  return (
    <div>
      <NudosGenericModal
        closeModalCallback={closeAndRestoreList}
        modalContent={
          <NudosModalContent
            customWidth="780px"
            customHeight="580px"
            toCloseModal={closeAndRestoreList}
            modalContentTitle="En proceso a Activo"
            CustomModalComponent={
              <ConfirmedToActiveModalLsContent
                modalButtonIsLoading={modalButtonIsLoading}
                updateDataCallback={updateDataCallback}
                logisticServiceDetails={logisticServiceDetails}
                closeModalAfterSubmitCallback={closeModalAfterSubmitCallback}
                selectedLogisticServiceDataForModal={selectedLogisticServiceDataForModal}
              />
            }
          />
        }
      />
    </div>
  );
};

export default ConfirmedToActiveModalLS;
